import { Box, Skeleton, Stack } from '@mui/material';

export const MemberEvaluationSkeleton = () => {
  return (
    <Box px={{ tablet: 3 }} pb={{ tablet: 3 }} maxWidth={550} m="auto">
      <Skeleton width={280} height={36} sx={{ mb: 1 }} />
      <Skeleton width={140} height={20} sx={{ mb: 3 }} />

      <Box
        mx={{ xs: -2, tablet: 0 }}
        sx={{ p: 2, mb: 3, backgroundColor: 'highlight.neutral' }}
      >
        <Stack direction="column" spacing={2} alignItems="flex-start">
          <Box display="flex" gap={2} alignItems="center" width="100%">
            <Skeleton variant="circular" width={52} height={52} />
            <Skeleton width={300} height={24} />
          </Box>
          <Skeleton
            width={120}
            height={32}
            variant="rectangular"
            sx={{ borderRadius: 2 }}
          />
        </Stack>
      </Box>

      <Stack spacing={2} mb={4}>
        {[...Array(4)].map((_, idx) => (
          <Stack
            key={idx}
            direction="row"
            alignItems="center"
            spacing={2}
            pl={{ tablet: 2 }}
          >
            <Skeleton width={120} height={24} />
            <Skeleton
              width={100}
              height={32}
              variant="rectangular"
              sx={{ borderRadius: 2 }}
            />
          </Stack>
        ))}
      </Stack>

      <Box ml={{ tablet: 2 }}>
        <Skeleton width={300} height={24} sx={{ mb: 1 }} />
        <Skeleton width="100%" height={60} />
      </Box>
    </Box>
  );
};
